export const schemesData = [
  {
    name: 'PM Mudra Yojana (PMMY)',
    slug: 'pm-mudra-yojana',
    description: 'Provides collateral-free loans up to ₹10 Lakhs to micro/small business enterprises in manufacturing, trading, and services.',
    category: 'loan',
    ministry: 'Ministry of Finance',
    eligibility: {
      turnoverMin: 0,
      turnoverMax: 500, // 5 Cr
      yearsInBusinessMin: 0,
      isStartup: true,
    },
    benefits: [
      'Loans divided into Shishu (up to ₹50,000), Kishor (up to ₹5 Lakhs), and Tarun (up to ₹10 Lakhs)',
      'No collateral or security required',
      'Extremely low processing fees and interest rates',
    ],
    applicationProcess: [
      'Prepare business plan and gather KYC documents',
      'Apply online on Udyamitra portal or visit any public/private sector bank branch',
      'Submit the Mudra application form along with business registration proof',
      'Bank verifies application and disburses loan',
    ],
    documents: ['Aadhaar Card', 'PAN Card', 'Proof of identity/residence', 'Business registration certificate (Udyam)', 'Last 6 months bank statements'],
    isPopular: true,
  },
  {
    name: 'CGTMSE Collateral-Free Credit',
    slug: 'cgtmse-collateral-free-credit',
    description: 'Enables micro and small enterprises to secure collateral-free credit/loans up to ₹5 Crore from registered financial institutions.',
    category: 'loan',
    ministry: 'Ministry of MSME',
    eligibility: {
      turnoverMin: 5,
      turnoverMax: 25000, // 250 Cr
      yearsInBusinessMin: 1,
      creditScoreMin: 650,
    },
    benefits: [
      'Credit limit expanded up to ₹5 Crore (historically ₹2 Crore)',
      'No third-party guarantee or tangible collateral required',
      'Trust guarantees up to 75-85% of the principal loan amount',
    ],
    applicationProcess: [
      'Prepare a detailed business project report',
      'Submit loan application to CGTMSE-registered bank/NBFC',
      'Bank sanctions loan under CGTMSE cover and pays premium directly to trust',
    ],
    documents: ['Udyam Registration', 'Project report', 'Audited financial statements (2 years)', 'GST returns', 'ITR copies'],
    isPopular: true,
  },
  {
    name: 'Stand-Up India Scheme',
    slug: 'stand-up-india-scheme',
    description: 'Promotes entrepreneurship at the grassroots level by offering composite loans from ₹10 Lakhs up to ₹1 Crore specifically for SC/ST and Women entrepreneurs.',
    category: 'loan',
    ministry: 'Ministry of Finance',
    eligibility: {
      turnoverMin: 0,
      isWomenOnly: true,
      isSCSTOnly: true,
      isStartup: true,
    },
    benefits: [
      'Composite loan (term loan and working capital) between ₹10 Lakhs and ₹1 Crore',
      'Covers up to 75% of the project cost',
      'Repayment period of 7 years with a maximum moratorium of 18 months',
    ],
    applicationProcess: [
      'Apply online through Stand-Up India portal or visit nearest bank branch',
      'Get matched with local handholding support if required',
      'Fill in applicant details, upload documents, and track application online',
    ],
    documents: ['Proof of SC/ST or Women ownership (min 51% stake)', 'Aadhaar & PAN', 'Project report', 'Partnership deed or company incorporation papers'],
    isPopular: true,
  },
  {
    name: 'PMEGP Subsidy Scheme',
    slug: 'pmegp-subsidy-scheme',
    description: 'Credit-linked subsidy program for setting up new micro-enterprises in manufacturing and service sectors, offering subsidies up to 35%.',
    category: 'subsidy',
    ministry: 'Ministry of MSME / KVIC',
    eligibility: {
      turnoverMin: 0,
      turnoverMax: 100,
      yearsInBusinessMin: 0,
      isStartup: true,
    },
    benefits: [
      'Subsidy of 15% to 25% for general category in urban/rural areas',
      'Subsidy of 25% to 35% for special categories (women, SC/ST, OBC, minorities)',
      'Subsidized loan for projects up to ₹50 Lakhs (manufacturing) and ₹20 Lakhs (services)',
    ],
    applicationProcess: [
      'Apply online on KVIC portal (PMEGP e-Portal)',
      'Upload project report and get approval from District Task Force Committee',
      'Bank sanctions loan and KVIC releases subsidy to lock-in account for 3 years',
    ],
    documents: ['Aadhaar', 'Project report', 'Education certificate (min VIII pass for large projects)', 'Category/caste certificate'],
    isPopular: true,
  },
  {
    name: 'Startup India Income Tax Holiday',
    slug: 'startup-india-tax-holiday',
    description: 'Provides DPIIT-recognized startups with 100% tax exemption on profits for three consecutive years under Section 80-IAC.',
    category: 'tax',
    ministry: 'Ministry of Commerce & Industry',
    eligibility: {
      turnoverMax: 10000, // 100 Cr
      yearsInBusinessMax: 10,
      isStartup: true,
    },
    benefits: [
      '100% income tax exemption on business profits for any 3 out of 10 years',
      'Access to Startup India seed fund and fasttracked patent applications',
      'Self-certification for environmental and labor compliance laws',
    ],
    applicationProcess: [
      'Get DPIIT recognition online through Startup India portal',
      'Apply for Section 80-IAC exemption via the startup portal dashboard',
      'Inter-Ministerial Board (IMB) reviews and issues tax holiday certificate',
    ],
    documents: ['DPIIT Recognition Certificate', 'Memorandum of Association / Partnership deed', 'Write-up explaining innovative nature of business', 'Audited financial reports'],
    isPopular: false,
  },
  {
    name: 'Udyam Registration Benefits',
    slug: 'udyam-registration-benefits',
    description: 'Standard recognition certificate that unlocks subsidies on power, patents, delayed payment protection, and priority sector bank lending.',
    category: 'registration',
    ministry: 'Ministry of MSME',
    eligibility: {
      turnoverMin: 0,
      turnoverMax: 25000,
    },
    benefits: [
      'Protection against delayed payments (mandatory interest if unpaid > 45 days)',
      '50% subsidy on patent and trademark registration fees',
      'Concession on electricity bills and eligibility for government tenders',
    ],
    applicationProcess: [
      'Register for free on the official Udyam Portal using Aadhaar',
      'Self-verify details (GSTIN and Income tax fetched automatically)',
      'Receive instant Udyam Registration Certificate online',
    ],
    documents: ['Aadhaar Card', 'PAN Card of owner/business', 'GSTIN (mandatory unless exempt)'],
    isPopular: true,
  },
  {
    name: 'Government e-Marketplace (GeM) Access',
    slug: 'gem-marketplace-access',
    description: 'Allows MSMEs to sell goods and services directly to various government departments and public sector units without paying bidding fees.',
    category: 'registration',
    ministry: 'Ministry of Commerce & Industry',
    eligibility: {
      turnoverMin: 0,
      yearsInBusinessMin: 0,
    },
    benefits: [
      'Direct access to government procurement worth thousands of crores',
      'Exemption from Earnest Money Deposit (EMD) and tender fees for MSMEs',
      'Guaranteed payments and streamlined online ordering mechanism',
    ],
    applicationProcess: [
      'Register as Seller on GeM portal using Aadhaar / PAN',
      'Complete company profile verification and bank validation',
      'Upload product catalogs or list offered services to start selling',
    ],
    documents: ['Udyam Registration', 'Aadhaar & PAN', 'Bank details (cancelled cheque)', 'Income Tax Returns (last 2 years)'],
    isPopular: false,
  },
  {
    name: 'TReDS Bill Discounting Scheme',
    slug: 'treds-bill-discounting-scheme',
    description: 'An online electronic platform that facilitates discounting of trade receivables of MSMEs from corporate and government buyers through multiple financiers.',
    category: 'loan',
    ministry: 'Reserve Bank of India',
    eligibility: {
      turnoverMin: 10,
      yearsInBusinessMin: 1,
    },
    benefits: [
      'Enables quick conversion of trade invoices into cash within 24-48 hours',
      'No recourse to the MSME supplier in case buyer delays payment',
      'Highly competitive discounting rates via auction among multiple banks/financiers',
    ],
    applicationProcess: [
      'Register on an approved TReDS platform (RXIL, M1xchange, Invoicemart)',
      'Upload outstanding trade invoices approved by corporate/PSU buyer',
      'Financiers place bids, supplier accepts best bid, and funds are disbursed',
    ],
    documents: ['Udyam Registration', 'PAN and GSTIN', 'Audited financials', 'Board resolution / authorization letter'],
    isPopular: false,
  },
  {
    name: 'RAMP Quality Upgrade Grant',
    slug: 'ramp-quality-upgrade-grant',
    description: 'World Bank-supported program to raise capacity, resolve delayed payments, and support technology upgrades in traditional MSME clusters.',
    category: 'subsidy',
    ministry: 'Ministry of MSME',
    eligibility: {
      turnoverMin: 50,
      yearsInBusinessMin: 2,
    },
    benefits: [
      'Grants and soft loans for modernizing machinery and adopting digital tools',
      'Consulting support for entering export markets and improving quality standards',
      'Capacity building workshops and skill training programs for staff',
    ],
    applicationProcess: [
      'Register interest through active RAMP projects on MSME portal',
      'Submit business assessment and technology upgrade request plan',
      'Approved proposals get financial grants transferred directly for equipment/training',
    ],
    documents: ['Udyam Registration', 'Detailed modernization plan', 'Audited financials (3 years)', 'GST returns'],
    isPopular: false,
  },
  {
    name: 'CLCSS Technology Upgradation Subsidy',
    slug: 'clcss-technology-subsidy',
    description: 'Provides 15% upfront capital subsidy for micro and small enterprises to modernize their plant and machinery with state-of-the-art technology.',
    category: 'subsidy',
    ministry: 'Ministry of MSME',
    eligibility: {
      turnoverMin: 10,
      yearsInBusinessMin: 1,
    },
    benefits: [
      '15% capital subsidy up to a maximum loan limit of ₹1 Crore',
      'Helps reduce cost of production and increase output quality',
      'Applicable on 50+ sub-sectors including plastics, textiles, food processing',
    ],
    applicationProcess: [
      'Apply to the primary lending institution (PLI) along with loan request for machinery',
      'PLI submits subsidy claim online to the Office of DC (MSME)',
      'Subsidy released to PLI and credited to applicant’s account after verification',
    ],
    documents: ['Udyam Registration', 'Loan sanction copy from bank', 'Invoices of machinery purchased', 'Caste/category certificate (for SC/ST special preference)'],
    isPopular: false,
  }
];
export default schemesData;
